import { render, staticRenderFns } from "./quantidade-decimal-input.vue?vue&type=template&id=be5f76e6"
import script from "./quantidade-decimal-input.vue?vue&type=script&lang=js"
export * from "./quantidade-decimal-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports